import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { Area } from 'src/models/area-builder/area.model';
import { AreaType } from 'src/models/area-builder/area-type.enum';
import { EvButtonComponent } from 'src/app/shared-components/ev-button/ev-button.component';
import { AreasStore } from 'src/stores/area-builder.store';
import { getParentAreaKey, getPostNumberWithFourDigits } from 'src/app/area-builder/area-builder.utils';

@Component({
    selector: 'area-item',
    templateUrl: './area-item.component.html',
    styleUrl: './area-item.component.scss',
    imports: [
        TitleCasePipe,
        EvButtonComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AreaItemComponent {
  AreaType = AreaType;
  readonly areasStore = inject(AreasStore);

  area: InputSignal<Area> = input.required();
  parent: InputSignal<Area> = input.required();

  navigated = output<Area>();
  shiftSelect = output<Area>();

  isSelected = computed(() => this.areasStore.selectedAreas()
    .some((x: Area) => x.areaId === this.area().areaId && x.areaType === this.area().areaType));

  nrOfChildren = computed(() => {
    const parentKey = getParentAreaKey(this.area().areaId, this.area().areaType);
    return this.areasStore.childrenCounter()[parentKey] || 0;
  });

  isSelectable = computed(() => {
    if (this.nrOfChildren() > 0) return false;
    return true;
  });
  private parentKey = computed(() => {
    let parentAreaId;
    let parentAreaType;
    if (this.area().areaType === AreaType.County) {
      parentAreaId = 0;
      parentAreaType = AreaType.Undefined; // Vil da egentlig være Country som parent
    } else {
      parentAreaId = this.parent().areaId;
      parentAreaType = this.parent().areaType;
    }
    return getParentAreaKey(parentAreaId, parentAreaType);
  });

  handleSelected(event: any) {
    event.stopPropagation();
    if (event.shiftKey && this.areasStore.getPreviousSelectedArea() != null) {
      this.shiftSelect.emit(this.area());
    }
    this.areasStore.addSelectedArea(this.area(), this.parentKey());
  }

  handleUnselected(event: any) {
    event.stopPropagation();
    if (event.shiftKey && this.areasStore.getPreviousSelectedArea() != null) {
      this.shiftSelect.emit(this.area());
    }
    this.areasStore.removeSelectedArea(this.area(), this.parentKey());
  }

  handleNavigated(event: any) {
    event.stopPropagation();
    this.navigated.emit(this.area());
  }

  hasSubStructure() {
    switch (this.area().areaType) {
      case AreaType.County:
      case AreaType.Municipality:
        return true;
      case AreaType.CityDistrict:
        return this.parent().areaId === 3; // Kun Oslo har delbydeler
      default:
        return false;
    }
  }

  postNumberWithAllDigits(postNumber: number) {
    return getPostNumberWithFourDigits(postNumber);
  }
}
